import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/app.materials';
import { ConfidenceLabelPipe } from '../../shared/services/confidence-label.pipe';

@Component({
  selector: 'app-effective-views',
  templateUrl: './effective-views.component.html',
  styleUrls: ['./effective-views.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, ConfidenceLabelPipe],
})
export class EffectiveViewsComponent {
  @Input() payload: any[] = [];
  @Input() loading = false;
  @Input() error = '';
  @Input() resetEnabled = false;
  @Input() resetLoading = false;
  // Disables the Optimize button + shows a spinner while a run is computing.
  @Input() optimizing = false;

  @Output() generate = new EventEmitter<void>();
  @Output() optimize = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();

  collapsed = false;

  get showOptimize(): boolean {
    return !this.error && (!!this.payload?.length || this.resetEnabled);
  }
}
